<script lang="ts">
import { useUserStore } from '~/store'

export default {
    name: 'GeojsonUrl',
    props: {
        intentionsOrOpportunities: { type: String, required: true },
    },
    data() {
        const userStore = useUserStore()
        return {
            userStore,
            tooltipTexts: {
                voirie: 'Copier',
            } as Record<string, string>,
        }
    },
    computed: {
        hasKeyUrlGeojson(): boolean {
            return !!this.userStore.currentUser?.key_url_geojson
        },
        userEmail(): string {
            return this.userStore.user?.email
        },
        userHashKey(): string {
            return this.userStore.user?.key_url_geojson
        },
        applicationTableSlug(): string {
            if (!['intentions', 'opportunities'].includes(this.intentionsOrOpportunities)) {
                console.warn('Invalid value for intentionsOrOpportunities (must be \'intentions\' or \'opportunities\')')
            }
            return this.intentionsOrOpportunities
        },
    },
    methods: {
        getGeojsonUrl(applicationTableSlug: string | null): string {
            const apiUrl = useRuntimeConfig().public.apiBase
            return `${apiUrl}/geojson/voirie/${applicationTableSlug}.geojson?user=${this.userEmail}&key=${this.userHashKey}`
        },
        async copy(applicationTableSlug: string) {
            const url = this.getGeojsonUrl(applicationTableSlug)
            try {
                await navigator.clipboard.writeText(url)
                this.tooltipTexts.voirie = 'Copié ✅'

                // reset back to "Copier" after 1.5s
                setTimeout(() => {
                    this.tooltipTexts.voirie = 'Copier'
                }, 1500)
            }
            catch (err) {
                console.warn(err)
                this.tooltipTexts.voirie = 'Erreur ❌'
                setTimeout(() => {
                    this.tooltipTexts.voirie = 'Copier'
                }, 1500)
            }
        },
    },
}
</script>

<template>
    <v-btn
        v-if="hasKeyUrlGeojson"
        v-tooltip="tooltipTexts.voirie"
        class="ma-2"
        variant="outlined"
        color="primary"
        @click="copy(applicationTableSlug)"
    >
        Flux GeoJson
    </v-btn>
</template>
